<router-outlet>
<!-- Angular routes output here -->
</router-outlet>
